import { Action, Reducer } from 'redux';
import {
  AddressByBodyshopState,
  AddressByBodyshopTypes,
  AddressByBodyshopActionTypes
} from './addressByBodyshopTypes';

export const INITIAL_STATE: AddressByBodyshopState = {
  addressByBodyshop: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const addressByBodyshopReducer: Reducer<AddressByBodyshopState> = (
  state: AddressByBodyshopState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as AddressByBodyshopActionTypes;
  switch (actionTypes.type) {
    case AddressByBodyshopTypes.GET_ADDRESSBYBODYSHOP:
      return {
        ...state,
        addressByBodyshop: { ...state.addressByBodyshop, isLoading: true }
      };
    case AddressByBodyshopTypes.SAVE_ADDRESSBYBODYSHOP:
      return {
        ...state,
        addressByBodyshop: {
          ...state.addressByBodyshop,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case AddressByBodyshopTypes.RESET_REDUCER_ADDRESSBYBODYSHOP:
      return {
        ...state,
        addressByBodyshop: INITIAL_STATE.addressByBodyshop
      };
    default:
      return state;
  }
};

export default addressByBodyshopReducer;
